module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-b2db3e7ac5718a50834bbadc42c84250.svg";